import { type ReactElement } from 'react';

import { cn } from '@/lib/cn';

/**
 * The ABOUEB mark: the logo's circle and wordmark on a white tile (the artwork has a white ground). The size comes from
 * `className`; the image fills the tile.
 */
export function AbouebMark({ className = 'h-9 w-9' }: { className?: string }): ReactElement {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid shrink-0 place-items-center overflow-hidden rounded-[11px_5px_11px_5px] bg-white shadow-[0_8px_20px_rgb(29_63_122/0.25)]',
        className,
      )}
    >
      <img
        src={`${import.meta.env.BASE_URL}icon-192.png`}
        alt=""
        className="h-full w-full object-contain"
      />
    </span>
  );
}
